import React from 'react';
import { styled } from '@mui/system';

export interface ContainerContentProps {
    children?: React.ReactNode;
}

const StyledGovContainerContent = styled('div')({
    display: 'block',
    margin: '0 auto',
    maxWidth: '70rem',
});

export default function ContainerContent(props: ContainerContentProps) {
    const { children } = props;

    return (
        <StyledGovContainerContent>
            {children}
        </StyledGovContainerContent>
    );
}